import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="px-6 py-4 text-center text-white">
      <p className="text-sm md:text-base">
        © Yizhao Yuan (袁乙钊). All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;